import { useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { api, formatApiErrorDetail } from "../../api";
import { MeetingFields } from "./MeetingForm";

const formFromMeeting = (m) => ({
  title: m.title,
  meeting_date: (m.meeting_date || "").slice(0, 10),
  location: m.location || "",
  description: m.description || "",
  status: m.status || "agendada",
  start_time: m.start_time || "",
  end_time: m.end_time || "",
  is_online: !!m.is_online,
  online_link: m.online_link || "",
});

export function MeetingEditModal({ meeting, onClose, onSaved }) {
  const [form, setForm] = useState(() => formFromMeeting(meeting));

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.patch(`/admin/meetings/${meeting.id}`, {
        ...form,
        start_time: form.start_time || null,
        end_time: form.end_time || null,
      });
      toast.success("Reunião atualizada.");
      onSaved();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-50 grid place-items-center p-4" data-testid="meeting-edit-modal">
      <div className="bg-white rounded-md w-full max-w-lg p-6 max-h-[90vh] overflow-y-auto">
        <div className="flex items-start justify-between gap-4 mb-4">
          <div>
            <div className="text-[11px] uppercase tracking-[0.25em] text-slate-500">Editar reunião</div>
            <h3 className="mt-1 font-serif-display text-2xl">{meeting.title}</h3>
          </div>
          <button onClick={onClose} data-testid="meeting-edit-close" className="text-slate-500 hover:text-slate-900" aria-label="Fechar">
            <X size={20} />
          </button>
        </div>
        <form data-testid="meeting-edit-form" onSubmit={submit} className="grid grid-cols-2 gap-3">
          <MeetingFields form={form} setForm={setForm} prefix="meeting-edit" withStatus />
          <div className="col-span-2 flex gap-2 justify-end">
            <button type="button" onClick={onClose} data-testid="meeting-edit-cancel"
              className="px-4 py-2 border border-slate-300 text-[11px] uppercase tracking-[0.22em] hover:border-[#002776]">
              Cancelar
            </button>
            <button data-testid="meeting-edit-submit"
              className="px-5 py-2 bg-[#0A0F14] text-white text-[11px] uppercase tracking-[0.22em] hover:bg-[#002776]">
              Salvar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
